import { AppModal, PrimaryButton, SecondaryButton, styleVariables } from '@lib/common';
import { Space } from 'antd';
import styled from 'styled-components';
import { PublishScoreForm } from './publish-score-form.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Description = styled.p.withConfig({
  displayName: "publish-score-modalcomponent__Description",
  componentId: "sc-wdix9z-0"
})(["margin:0 0 20px;color:", ";font-size:14px;line-height:22px;"], styleVariables.colors.grey70);
export var PublishScoreModal = function PublishScoreModal(props) {
  var form = props.form,
      label = props.label,
      isModalVisible = props.isModalVisible,
      errorLabel = props.errorLabel,
      isDisabledPublishButton = props.isDisabledPublishButton,
      isLoadingPublishScore = props.isLoadingPublishScore,
      onCancelModal = props.onCancelModal,
      onContinue = props.onContinue,
      onFormValuesChange = props.onFormValuesChange;
  return /*#__PURE__*/_jsxs(AppModal, {
    width: 560,
    centered: true,
    open: isModalVisible,
    onCancel: onCancelModal,
    title: label.title,
    footer: /*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      size: "small",
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        onClick: onCancelModal,
        disabled: isLoadingPublishScore,
        children: label.cancel
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        size: "middle",
        onClick: onContinue,
        loading: isLoadingPublishScore,
        disabled: isDisabledPublishButton || isLoadingPublishScore,
        children: label["continue"]
      })]
    }),
    children: [/*#__PURE__*/_jsx(Description, {
      children: label.description
    }), /*#__PURE__*/_jsx(PublishScoreForm, {
      form: form,
      label: label,
      onFormValuesChange: onFormValuesChange,
      errorLabel: errorLabel
    })]
  });
};